<!-------------- Header Image --------------->
<div class="full-width-image-container">
  <img src="../../assets/AdobeStock_3558442.jpeg" alt="Header Image" />
</div>

<!-------------- Button Row --------------->
<div class="button-row">
  <a routerLink="/human-resources" routerLinkActive="active" class="icon-link">
    <button class="icon-button">
      <img src="../../assets/img6.png" alt="Policy and Benefits" class="icon-image" />
      <span class="button-text">Human
        <hr style="border: none; border-bottom: 0px solid #333; width: 20%" class="space" />
        Resources
      </span>
    </button>
  </a>

  <a routerLink="/marketing" routerLinkActive="active" class="icon-link">
    <button class="icon-button">
      <img src="../../assets/marketing.png" alt="Marketing" class="icon-image" />
      <span class="button-text"><br>
        <hr style="border: none; border-bottom: 0px solid #333" class="space-two" />Marketing
      </span>
    </button>
  </a>

  <a routerLink="/safety" routerLinkActive="active" class="icon-link">
    <button class="icon-button">
      <img src="../../assets/img3.png" alt="Safety" class="icon-image" />
      <span class="button-text"><br>
        <hr style="border: none; border-bottom: 0px solid #333" class="space-two" />Safety
      </span>
    </button>
  </a>

  <a routerLink="/information-technology" routerLinkActive="active" class="icon-link">
    <button class="icon-button">
      <img src="../../assets/img10.png" alt="IT Ticket" class="icon-image" />
      <span class="button-text"><br>
        <hr style="border: none; border-bottom: 0px solid #333" class="space-two" />IT
      </span>
    </button>
  </a>

  <a routerLink="/standards" routerLinkActive="active" class="icon-link">
    <button class="icon-button">
      <img src="../../assets/img7.png" alt="Standards" class="icon-image" />
      <span class="button-text"><br>
        <hr style="border: none; border-bottom: 0px solid #333" class="space-two" />Standards
      </span>
    </button>
  </a>

  <a routerLink="/learning" class="icon-link">
    <button class="icon-button">
      <img
        src="../../assets/trainingandreferencesbutton.png"
        alt="Training and References"
        class="icon-image"
      />
      <span class="button-text">Training and
        <hr style="border: none; border-bottom: 0px solid #333" class="space-two" />
        References
      </span>
    </button>
  </a>

  <a routerLink="/training-req" routerLinkActive="active" class="icon-link">
    <button class="icon-button">
      <img src="../../assets/img5.png" alt="Training Request" class="icon-image" />
      <span class="button-text">Training
        <hr style="border: none; border-bottom: 0px solid #333" class="space-two" />
        Request
      </span>
    </button>
  </a>
</div>
<br />

<!-------------- Quick Links --------------->
<div class="quick-links-section">
  <div class="quick-links-container">
    <a href="https://www.trueatlas.com/" class="quick-link-item" target="_blank">
      <img src="../../assets/img4.png" alt="TrueAtlas" />
      <span>TrueAtlas</span>
    </a>
    <a href="https://landpoint.bamboohr.com/home/" class="quick-link-item" target="_blank">
      <img src="../../assets/img2.png" alt="BambooHR" />
      <span>BambooHR</span>
    </a>
    <a href="https://www.concursolutions.com/" class="quick-link-item" target="_blank">
      <img src="../../assets/concur1.PNG" alt="Concur" />
      <span>Concur</span>
    </a>
    <a href="https://mfc.frankcrum.com/login" class="quick-link-item" target="_blank">
      <img src="../../assets/frank2.png" alt="FrankCrum" />
      <span>Frank Crum</span>
    </a>
    <a href="https://participant.empower-retirement.com/participant/#/login" class="quick-link-item" target="_blank">
      <img src="../../assets/Empowerbg.png" alt="Empower" />
      <span>Empower</span>
    </a>
    <a href="https://www.employeenavigator.com/benefits/Account/Login" class="quick-link-item" target="_blank">
      <img src="../../assets/employee-navigator.png" alt="Employee Navigator" style="transform: scaleY(0.9);" />
      <span>Employee Navigator</span>
    </a>
    <a href="https://health.curative.com/" class="quick-link-item" target="_blank">
      <img src="../../assets/curative2.png" alt="Curative Health" />
      <span>Curative</span>
    </a>
    <a href="https://www.vsp.com/" class="quick-link-item" target="_blank">
      <img src="../../assets/vsp.png" alt="Vision" />
      <span>Vision Care</span>
    </a>
    <a href="https://www.shieldbenefits.com/landpoint/overview" class="quick-link-item" target="_blank">
      <img src="../../assets/legalshield.png" alt="LegalShield" />
      <span>LegalShield</span>
    </a>
  </div>
</div>

<hr class="hr2" />

<!-------------- Submit Tickets and Feedback Buttons --------------->
<div class="button-group">
  <div class="button-container">
    <a mat-raised-button href="https://landpoint.freshservice.com/support/home" color="primary" target="_blank">Submit HR or IT Request</a>
  </div>
</div>

<div class="button-group">
  <div class="button-container">
    <div class="button-title">Got an idea or a suggestion for management?</div>
    <a mat-raised-button routerLink="/feedback" routerLinkActive="active" color="primary">Submit Feedback</a>
  </div>
</div>

<!-------------- Days Since Last Injury --------------->
<div class="top">
  <div>Do The <span>Right Thing</span></div>
  <div>On Point <span>With Safety</span></div>
  <div>Roll up <span>Your Sleeves</span></div>
</div>

<div class="iframe-title">Days Since Last Lost Time Injury:</div>
<div class="safety-counter-value">
  <p>{{ daysSinceInjury !== null ? daysSinceInjury : '—' }}</p>
</div>
<br /><br /><br />

<!-------------- Newsletters + News --------------->
<div class="hub-row">

<div class="newsletter-container">
  <div class="newsletter-section">
    <h3>Monthly Newsletter</h3>
    @if (latestNewsletter) {
      <app-news-item-card [newsItem]="latestNewsletter" [hideMetadata]="true"></app-news-item-card>
    }
    <hr class="hr2" />
    <a routerLink="/newsletter-archive" class="archive-link">View Archive</a>
  </div>
</div>

<!-------------- News Section --------------->
<div class="news-container">
  <div class="news-section">
    <h3>News and Announcements</h3>
    <div class="news-carousel">
      @for (news of carouselAnnouncements; track news; let i = $index) {
        <div class="news-card" [class.active]="i === currentNewsIndex" (mouseenter)="newsIsHovered = true" (mouseleave)="newsIsHovered = false">
          <app-news-item-card [newsItem]="news"></app-news-item-card>
          @if (i === currentNewsIndex) {
            <button class="carousel-control prev" (click)="prevNews()">
              <mat-icon>arrow_back_ios</mat-icon>
            </button>
            <button class="carousel-control next" (click)="nextNews()">
              <mat-icon>arrow_forward_ios</mat-icon>
            </button>
          }
        </div>
      }
    </div>
  </div>
</div>

</div><!-- /.hub-row -->

<br /><br />

<!-------------- Calendar, Anniversaries, Birthdays --------------->
<div class="social-hub">
  <div class="flex-row">
    <!-- Calendar -->
    <div class="calendar-container">
      <mat-card class="calendar-card">
        <h3>Landpoint Calendar</h3>
        <mat-calendar
          [(selected)]="selectedDate"
          [dateClass]="dateClass"
        ></mat-calendar>
      </mat-card>
      <!-- Important Dates -->
      <div class="calendar-events">
        <h3>Important Dates</h3>
        <ul>
          @for (event of importantDates; track event) {
            <li>
              <div class="calendar-time">{{ event.date | date : "MM/dd" }}</div>
              <div class="calendar-line"></div>
              <div class="calendar-details">
                <span class="calendar-title">{{ event.description }}</span>
                <span class="calendar-location">{{ event.info }}</span>
              </div>
            </li>
          }
        </ul>
      </div>
    </div>

    <!-- Birthdays, Anniversaries -->
    <div class="events-container">
      <div class="upcoming-events">
        <div class="upcoming-events-scroll">
          @if (currentTab === 0) {
            <div>
              <h3>Anniversaries</h3>
              <ul>
                @for (event of upcomingAnniversaries; track event) {
                  <li>
                    <div class="event-time">{{ event.date }}</div>
                    <div class="event-line"></div>
                    <div class="event-details">
                      <span class="event-title">{{ event.name }}</span>
                      <span class="event-location">{{ event.year }}</span>
                    </div>
                  </li>
                }
              </ul>
            </div>
          }
          @if (currentTab === 1) {
            <div>
              <h3>Birthdays</h3>
              <ul>
                @for (event of upcomingBdays; track event) {
                  <li>
                    <div class="event-time">{{ event.date }}</div>
                    <div class="event-line"></div>
                    <div class="event-details">
                      <span class="event-title">{{ event.name }}</span>
                      <span class="event-location">Happy Birthday!</span>
                    </div>
                  </li>
                }
              </ul>
            </div>
          }
        </div>
        <div class="tab-dots">
          <span (click)="switchTab(0)" [class.active]="currentTab === 0"></span>
          <span (click)="switchTab(1)" [class.active]="currentTab === 1"></span>
        </div>
      </div>
    </div>
  </div>
</div>

<!-------------- Social Media Buttons --------------->
<div class="social-media-section">
  <h3>Connect</h3>
  <div class="social-icons">
    <a href="https://twitter.com/landpointinc?lang=en" target="_blank">
      <img src="../../../assets/twitter-x.svg" alt="X (Twitter)" class="social-icon" />
    </a>
    <a href="https://www.linkedin.com/company/landpoint-inc-/" target="_blank">
      <img src="../../../assets/linkedin.svg" alt="LinkedIn" class="social-icon" />
    </a>
    <a href="https://www.facebook.com/landpointinc/" target="_blank">
      <img src="../../../assets/facebook.svg" alt="Facebook" class="social-icon" />
    </a>
    <a href="https://instagram.com/landpoint_?igshid=MzRlODBiNWFlZA==" target="_blank">
      <img src="../../../assets/instagram.svg" alt="Instagram" class="social-icon" />
    </a>
    <a href="https://www.youtube.com/@landpointinc" target="_blank">
      <img src="../../../assets/youtube.svg" alt="YouTube" class="social-icon" />
    </a>
  </div>
</div>

<br /><br /><br /><br />

<!-------------- Classifieds --------------->
<div class="announcement-section-title">Landpoint Classifieds</div>
<p class="dev-p">
  <b>Please note:</b> All sales of equipment listed in the classifieds are final and products are sold as is.
  Payment is required by check. Landpoint makes no representations and offers no support for products once purchased.
  Purchases are offered on a first-come, first-served basis. Priority to purchase will be given to the first email received.
</p>
<br />
<p class="dev-p">
  <a mat-raised-button href="https://landpoint227.sharepoint.com/:l:/s/LandpointHub/JAB-xm630YOjSrY_QuWnc9OzAT_AybYu3fi1vTUQ9jDJhYg" target="_blank" color="primary">
    View Classified Listings
  </a>
</p>
<br /><br />

<!-------------- Weather Radar --------------->
<div class="announcement-section-title">Weather Radar</div>
<p class="dev-p">
  <a routerLink="/weather" class="policy-link" routerLinkActive="active">View Weather For All Offices</a>
</p>
<br />
<div class="weather-wrapper">
  <div class="iframe-container-weather">
    <iframe
      src="https://embed.windy.com/embed2.html?lat=37.510&lon=-100.107&detailLat=37.562&detailLon=-97.383&width=650&height=450&zoom=4&level=surface&overlay=radar&product=radar&menu=&message=&marker=&calendar=24&pressure=&type=map&location=coordinates&detail=&metricWind=default&metricTemp=default&radarRange=-1"
      frameborder="0"
    ></iframe>
  </div>
</div>
<br /><br /><br />

<!-------------- Travel --------------->
<p class="dev-icon">
  <mat-icon class="list-icon">hotel</mat-icon
  ><mat-icon class="list-icon">airline_stops</mat-icon
  ><mat-icon class="list-icon">flight_takeoff</mat-icon>
</p>
<div class="announcement-section-title-logo">Landpoint Travel</div>
<p class="dev-p">Looking for travel help for your next work trip?</p>
<br />
<p class="dev-p">
  <a routerLink="/travel" class="policy-link" routerLinkActive="active">View Travel Rates & Codes</a>
</p>

<br /><br /><br />

<div class="coming-soon-section">
  <p class="alert"></p>
</div>
<br /><br /><br /><br />
